import { Step } from "react-joyride";

export const tourStepsShop = (): Step[] => {
  const steps: Step[] = [
    {
      target: "h1.mb-8",
      content:
        "The shop is for a one-time license. You can use the site without buying, but a license unlocks premium features.",
      disableBeacon: true,
    },
    {
      target: ".shop-licenses",
      content:
        "There are two options: a single license for one teacher, or a pack of five for a team.",
    },
    {
      target: ".single-license",
      content:
        "Single license is a one-time purchase for one person. Sign in, add it to your cart, then adjust quantity in the cart if you need more.",
    },
    {
      target: ".multi-license",
      content:
        "The multi pack is five licenses. Add it to your cart the same way, then checkout when ready.",
    },
  ];

  return steps;
};
